/* eslint-disable react/no-danger */
/* @flow */
import React from 'react';
import sanitizeHtml from 'sanitize-html';

/**
 * The default set of allowed tags is a bit restrictive so we add more here.
 */
const sanitize = (html: string) => {
  return sanitizeHtml(html, {
    allowedTags: sanitizeHtml.defaults.allowedTags.concat([
      'h1',
      'h2',
      'img',
    ]),
    allowedAttributes: {
      ...sanitizeHtml.defaults.allowedAttributes,
      img: ['src'],
    },
  });
};

type MarkdownProps = {
  content: string,
  className?: string,
};
export const Markdown = (props: MarkdownProps) => (
  <div
    className={props.className}
    dangerouslySetInnerHTML={{ __html: sanitize(props.content) }}
  />
);




// WEBPACK FOOTER //
// ./web_modules/trustar/components/Markdown.js